import React from 'react';
import styled from '@benzinga/themetron';

// TODO: Figure out import
// import { InvestingChannelBottomMargin } from '@benzinga/ads';
const InvestingChannelBottomMargin = '1rem';

// const InvestingChannel = React.lazy(() =>
//   import('@benzinga/ads').then(module => {
//     return { default: module.InvestingChannel };
//   }),
// );

interface InvestingChannelBlockProps {
  block: any;
}

export const InvestingChannelBlock: React.FC<InvestingChannelBlockProps> = ({ block }) => {
  const minHeight = block?.attrs?.data?.height || null;

  return (
    <React.Suspense fallback={<FallbackWrapper minHeight={minHeight} />}>
      {/* TODO: Return back after Raptive fully setup */}
      {/* <InvestingChannel {...block.attrs.data} /> */}
    </React.Suspense>
  );
};

const FallbackWrapper = styled.div<{ minHeight: number }>`
  min-height: ${({ minHeight }) => (minHeight ? `calc(${minHeight}px + ${InvestingChannelBottomMargin})` : `auto`)};
`;
